import * as React from "react";
import { getID } from "../../../utils/IdGenerator";

export type Props = {
	/**
	 * Radio buttons with the same name are treated as belonging to the same group.
	 * Only one button in a group can be selected at once.
	 */
	name: string;
	value: string | number;
	checked: boolean;
	onChange: (value: string) => void;
	required?: boolean;
	disabled?: boolean;
	label: string;
};

type State = {
	id: string;
};

/**
 * A radio button.
 */
export class Radio extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			id: getID()
		};
	}

	public render() {
		return (
			<div className="radio__multiple-choice">
				<input
					id={this.state.id}
					type="radio"
					name={this.props.name}
					value={this.props.value}
					checked={this.props.checked}
					onChange={e => this.props.onChange(e.target.value)}
					required={this.props.required}
					disabled={this.props.disabled}
				/>
				<label htmlFor={this.state.id}>{this.props.label}</label>
			</div>
		);
	}
}
